import { useEventManifest } from "@hooks/useEventManifest"
import { useSquadupState } from "./useSquadUp"
import { useMemo } from "react"
import { useIsSSR } from "eddev/routing"

const EMPTY_CART = { items: [], quantity: 0 }

export function useCart() {
  if (!env.client) return EMPTY_CART

  const manifest = useEventManifest()
  const state = useSquadupState()
  const cart = state.cart
  const quantity = state.quantity

  const items = useMemo(() => {
    return (
      cart?.map((item) => ({
        ...item,
        siteEvent: manifest.data?.films.find((film) =>
          film.sessions.some((session) => session.ticketEventId === item.event.id),
        ),
      })) ?? []
    )
  }, [manifest.data, cart])

  if (useIsSSR()) return EMPTY_CART

  return {
    items,
    quantity,
  }
}

export type CartItem = ReturnType<typeof useCart>["items"][number]
